// Typing placeholder animation
class TypingPlaceholder {
  constructor(inputElement, options = {}) {
    this.input = inputElement;
    this.fullText = this.input.getAttribute('data-typing-placeholder') || this.input.placeholder;
    this.typingSpeed = options.typingSpeed || 100;
    this.pauseDuration = options.pauseDuration || 2000;
    this.deletingSpeed = options.deletingSpeed || 50;
    this.currentIndex = 0;
    this.isTyping = true;
    this.isDeleting = false;
    this.animationTimeout = null;

    // Bind methods
    this.type = this.type.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);

    this.initialize();
  }

  initialize() {
    // Start the typing animation
    this.startTyping();

    // Handle focus and blur events
    this.input.addEventListener('focus', this.onFocus);
    this.input.addEventListener('blur', this.onBlur);

    // Stop animation only when user actually types
    this.input.addEventListener('input', () => {
      if (this.input.value !== '') {
        this.clearAnimation();
      }
    });
  }

  startTyping() {
    if (this.input.value === '') {
      this.currentIndex = 0;
      this.isDeleting = false;
      this.type();
    }
  }

  type() {
    if (this.input.value !== '') {
      // Stop animation if user has typed something
      this.clearAnimation();
      return;
    }

    if (!this.isDeleting) {
      // Typing mode
      if (this.currentIndex < this.fullText.length) {
        this.currentIndex++;
        this.input.placeholder = this.fullText.substring(0, this.currentIndex);
        this.animationTimeout = setTimeout(
          this.type,
          this.typingSpeed + (Math.random() * 50 - 25) // Add slight randomness
        );
      } else {
        // Finished typing, pause before deleting
        this.animationTimeout = setTimeout(() => {
          this.isDeleting = true;
          this.type();
        }, this.pauseDuration);
      }
    } else {
      // Deleting mode
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.input.placeholder = this.fullText.substring(0, this.currentIndex);
        this.animationTimeout = setTimeout(this.type, this.deletingSpeed);
      } else {
        // Finished deleting, start typing again
        this.isDeleting = false;
        this.animationTimeout = setTimeout(this.type, 500);
      }
    }
  }

  onFocus() {
    // Don't stop animation on focus - only stop if user is actually typing
    if (this.input.value !== '') {
      this.clearAnimation();
    }
  }

  onBlur() {
    if (this.input.value === '') {
      this.startTyping();
    }
  }

  clearAnimation() {
    if (this.animationTimeout) {
      clearTimeout(this.animationTimeout);
      this.animationTimeout = null;
    }
  }

  destroy() {
    this.clearAnimation();
    this.input.removeEventListener('focus', this.onFocus);
    this.input.removeEventListener('blur', this.onBlur);
    this.input.removeEventListener('input', this.onFocus);
  }
}

// Initialize function
function initializeTypingPlaceholders() {
  const searchInputs = document.querySelectorAll('[data-typing-placeholder]:not([data-typing-initialized])');
  searchInputs.forEach(input => {
    new TypingPlaceholder(input, {
      typingSpeed: 80,
      pauseDuration: 2500,
      deletingSpeed: 40
    });
    input.setAttribute('data-typing-initialized', 'true');
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeTypingPlaceholders);
} else {
  initializeTypingPlaceholders();
}

// Also initialize after a short delay to catch dynamic content
setTimeout(initializeTypingPlaceholders, 500);

// Also handle dynamically added elements (for Shopify theme re-renders)
if (window.MutationObserver) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          const typingInputs = node.querySelectorAll?.[0] !== undefined
            ? node.querySelectorAll('[data-typing-placeholder]:not([data-typing-initialized])')
            : [];

          if (node.hasAttribute && node.hasAttribute('data-typing-placeholder') && !node.hasAttribute('data-typing-initialized')) {
            typingInputs.push(node);
          }

          typingInputs.forEach(input => {
            if (!input.hasAttribute('data-typing-initialized')) {
              new TypingPlaceholder(input, {
                typingSpeed: 80,
                pauseDuration: 2500,
                deletingSpeed: 40
              });
              input.setAttribute('data-typing-initialized', 'true');
            }
          });
        }
      });
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}
